<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-fill-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.0625 17L7 15.9375L10.9375 12L7 8.0625L8.0625 7L12 10.9375L15.9375 7L17 8.0625L13.0625 12L17 15.9375L15.9375 17L12 13.0625L8.0625 17Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
